import { differenceInDays } from 'date-fns';
import { ICustomerFeedbackGateway } from '../interfaces/CustomerFeedbackGateway';

const MAX_DAYS_CAN_SHOW_FEEDBACK_FORM_USERS = 30;

class CustomerFeedbackEntity {
  private readonly _gateway: ICustomerFeedbackGateway;
  constructor(gateway: ICustomerFeedbackGateway) {
    this._gateway = gateway;
  }

  setCustomerVisitorCustomData(data: Record<string, string>) {
    this._gateway.setCustomerVisitorCustomData(data);
  }

  canMakeFormByIdAvailable(id: string) {
    if (!this._gateway.isCsatByIdActivate(id)) {
      return false;
    }

    const dateNow = new Date();

    if (
      differenceInDays(dateNow, this._gateway.getLastTimeStampWhenFormDisplayedByFormId(id)) >
      MAX_DAYS_CAN_SHOW_FEEDBACK_FORM_USERS
    ) {
      return (
        differenceInDays(dateNow, this._gateway.getLastTimeStampWhenFormAnsweredByFormId(id)) >
        MAX_DAYS_CAN_SHOW_FEEDBACK_FORM_USERS
      );
    }

    return false;
  }

  showFeedbackFormById<T = void>(id: string, data?: T) {
    return this._gateway.showFeedbackFormById(id, data);
  }

  onLoaded(callback: Function, customData?: Record<string, string>) {
    return this._gateway.onLoaded(callback, customData);
  }

  onClose(callback: Function) {
    return this._gateway.onClose(callback);
  }
}

export default CustomerFeedbackEntity;
